import { cn } from "./lib/utils";
import { Button } from "./button";
import { useLocation, useNavigate } from "react-router-dom";
import { useState } from "react";

interface SidebarNavProps extends React.HTMLAttributes<HTMLElement> {
  items: {
    href: string;
    title: string;
  }[];
  setPage: (page: string) => void;
  page: string;
}

export function SidebarNav({
  className,
  items,
  setPage,
  page,
  ...props
}: SidebarNavProps) {
  return (
    <nav
      className={cn(
        "flex space-x-2 lg:flex-col lg:space-x-0 lg:space-y-1",
        className
      )}
      {...props}
    >
      {items.map((item) => (
        <Button
          key={item.title}
          onClick={() => setPage(item.title)}
          variant={"ghost"}
          className={cn(
            "justify-start",
            page === item.title && "bg-jd-blue/10"
          )}
        >
          {item.title}
        </Button>
      ))}
    </nav>
  );
}
